// Booked (or blocked) for the searched dates: shown as social proof, not selectable
export default function SoldOutCard({ car }) {
  return (
    <div
      data-testid={`bb-soldout-${car.id}`}
      aria-disabled="true"
      className="relative bg-[#0e0e0e] border border-white/10 flex flex-col md:flex-row items-stretch overflow-hidden min-h-[200px] cursor-not-allowed select-none"
    >
      <div className="relative w-full md:w-56 h-40 md:h-auto shrink-0 overflow-hidden bg-black">
        <img src={car.images?.[0]} alt={`${car.brand} ${car.model}`} className="w-full h-full object-cover grayscale opacity-50" />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <span data-testid={`bb-soldout-badge-${car.id}`} className="bg-[#ff3b3b] text-white font-display font-black text-xl md:text-2xl tracking-[0.2em] px-6 py-2 -rotate-12 shadow-[0_10px_30px_-5px_rgba(255,59,59,0.7)] border-2 border-white/80">
            SOLD OUT
          </span>
        </div>
      </div>
      <div className="flex-1 p-5 flex flex-col justify-between gap-3 min-w-0 opacity-70">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-white/60 font-bold mb-1">{car.brand}</div>
          <div className="font-display font-bold text-lg leading-tight mb-2 truncate text-white/80">{car.model}</div>
          <div className="text-[10px] uppercase tracking-widest text-white/40">{car.category}</div>
        </div>
        <div className="border-t border-white/10 pt-3 text-[11px] uppercase tracking-widest font-bold text-[#ff3b3b]">
          Già prenotata per queste date
        </div>
      </div>
    </div>
  );
}
